import React from 'react';

import { Container } from './styles';

const Dashboard: React.FC = () => <Container />;

export default Dashboard;
